<script lang="ts">

    export let show: any = false;

</script>

{#if show}
    <div class="feedback">
        <slot />
    </div>
{/if}

<style lang="scss">

    .feedback {
        font-size: 0.85rem;
        color: var(--bs-danger);
        margin: 0.5rem 0;
    }

</style>
